import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { useAuth } from '../context/AuthContext';

function Login() {
  const { isFirebaseConfigured, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || '/dashboard');
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <>
      <SEO title="Log In" />
      <section className="auth-panel">
        <h1>Log in</h1>
        {!isFirebaseConfigured && <p className="notice">Firebase env values are needed before auth will work.</p>}
        {error && <p className="error-text">{error}</p>}
        <form className="stacked-form" onSubmit={handleSubmit}>
          <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label>
          <label>Password<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} required /></label>
          <button className="button" type="submit">Log in</button>
        </form>
        <p className="muted">Log in to build your biography, daily history, and profile components.</p>
      </section>
    </>
  );
}

export default Login;
